import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { getLocationPathByPaymentOwner } from '../common';
import {
	requestAccessToken,
	GOCARDLESS_ACCESS_TOKEN_REQUEST, GOCARDLESS_ACCESS_TOKEN_SUCCESS, GOCARDLESS_ACCESS_TOKEN_FAILURE
} from './actions';
import { Alert } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import browserStorage from '../../../../common/services/browserStorage';

class AuthorizationCallback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accessTokenError: ''
		};
	}

	componentDidMount() {
		const { queryParams: { code }, storedData: { useSandbox, paymentConfigurationId }, history } = this.props;
		if (code) {
			this.props.requestAccessToken({ code, paymentConfigurationId, useSandbox },
				() => history.push(this.getBackPath()),
				(error) => this.setState({ accessTokenError: error }));
		}
	}

	getBackPath() {
		const { storedData: { paymentOwnerType, paymentOwnerId, franchiseeId } } = this.props;

		return `${getLocationPathByPaymentOwner(paymentOwnerType, paymentOwnerId, franchiseeId)}?method=gocardless`;
	}

	render() {
		const { queryParams: { error, error_description }, t } = this.props;

		const backPath = this.getBackPath();

		const errorMessage = (error && error_description) || this.state.accessTokenError;

		return <ReduxBlockUi block={GOCARDLESS_ACCESS_TOKEN_REQUEST} unblock={[GOCARDLESS_ACCESS_TOKEN_SUCCESS, GOCARDLESS_ACCESS_TOKEN_FAILURE]} renderChildren={false}>
			{errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
			{!errorMessage && <Alert bsStyle='success'>{t('GoCardless_OAuth_Success')}</Alert>}
			<Link to={backPath} className='btn btn-default'>{t('Common_Back')}</Link>
		</ReduxBlockUi>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { configuration: { franchisor } } = state;
	const queryParams = queryString.parse(ownProps.location.search);
	// required data is stored in local storage before redirecting to GoCardless authorization page, "state" param contains franchisorId and the local storage key separated with a '.'
	const stateParts = queryParams.state.split('.');
	const storedData = stateParts.length === 2 && JSON.parse(browserStorage.getFromSessionStorage(franchisor, stateParts[1]));

	return {
		queryParams,
		storedData
	};
};

export default connect(mapStateToProps, {
	requestAccessToken
})(withTranslation()(AuthorizationCallback));